import { format, isValid } from "date-fns";

/** Display created timestamp as e.g. Thursday, April 30th, 2026 (prefers `createdAt`, then `createdAtStr`). */
export function formatForecastDemandPlanningCreatedDisplay(row) {
    if (!row || typeof row !== "object") return "N/A";
    const raw = row.createdAt ?? row.createdAtStr;
    if (raw == null || raw === "") return "N/A";
    const d = raw instanceof Date ? raw : new Date(raw);
    if (!isValid(d)) return "N/A";
    return format(d, "EEEE, MMMM do, yyyy");
}
